<template>
<div id="app">
  <NavBar
    variant="dark">
    <span
      slot="brand">
      <Acorn/>
      Tall Oaks Environmental
    </span>
    <template
      slot="actions"
      class="menu">
      <BNavItem
        to="/services">
        Services
      </BNavItem>
      <BNavItem
        to="/team">
        Team
      </BNavItem>
      <BNavItem
        to="/projects">
        Projects
      </BNavItem>
      <BNavItem
        to="/notes">
        Notes
      </BNavItem>
      <BNavItem
        to="/#contact">
        Contact
      </BNavItem>
    </template>
  </Navbar>

  <div class="page-content">
    <transition
      name="fade"
      mode="out-in">
      <router-view/>
    </transition>
    <Footer id="footer"/>
  </div>
</div>
</template>

<script>
import NavBar from '@/components/nav/NavBar';
import Footer from '@/components/nav/Footer';
import Acorn from '@/components/nav/Acorn';

import {
  BNavItem,
} from 'bootstrap-vue';

export default {
  name: 'Toer',
  props: {},
  data() {
    return {};
  },
  components: {
    NavBar,
    Footer,
    Acorn,
    'b-nav-item': BNavItem,
  },
  created() {

  },
  watch: {
  },
  computed: {
    store(){
      return this.$store.state;
    },
    endpoint(){
      return process.env.VUE_APP_API;
    }
  },
  methods: {
    scrollTo(id){
      const el = document.getElementById(id.replace('#',''));
      if (el) {
        el.scrollIntoView({
          block: 'start',
          behavior: 'smooth',
        });
      }
    }
  }
};
</script>


<style lang="scss">
//@import url('https://cdnjs.cloudflare.com/ajax/libs/twitter-bootstrap/4.1.1/css/bootstrap-grid.css');
//@import url('https://fonts.googleapis.com/icon?family=Material+Icons');
//@import url('https://fonts.googleapis.com/css?family=Lato:900|Montserrat:500');
//@import url('https://material.io/color/#!/?view.left=0&view.right=0&primary.color=7CB342');
@import '~@/styles/variables';
@import '~@/styles/general';

body {
  margin: 0;
}
#app {
  //position: absolute;
  height: 100vh;
  width: 100vw;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $primary-color;
  display: flex;
  flex-direction: column;

  .nav-bar {
    flex: 0 0 4rem;
  }

  .page-content {
    height: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;


    .content {
      flex: 1;
    }

    .footer {
      margin-top: auto;
    }
  }
}
.menu {
  a {
    padding: 0 1rem;
  }
}

</style>
